import { useAppConfig } from 'src/components/App/useAppConfig';

/**
 * The value of this type will be lowercase language, and upper case country. Such as `en-AU`.
 *
 * @deprecated  Use `useMelwaysInfo().locale` from `@seek/melways-sites` instead.
 */
export const useLocale = () => {
  const { language, country } = useAppConfig();
  return `${language}-${country.toUpperCase()}`;
};
